import { Pipe, PipeTransform } from '@angular/core';
import DOMPurify from 'dompurify';

export class HtmlUtils {
  static extractTextFromHtml(html: string) {
    return DOMPurify.sanitize(
      new DOMParser().parseFromString(DOMPurify.sanitize(html), 'text/html')
        .documentElement.textContent as string,
    );
  }
}

@Pipe({
  name: 'extractHtmlText',
  standalone: false,
})
export class ExtractHtmlTextPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return HtmlUtils.extractTextFromHtml(value);
  }
}
